import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import { EVENT_NAMES, SOT_FIELDS } from 'ai/analytics/events';
import { buildPageContextFields, buildLyraAdviceFields } from 'ai/analytics/utils/sotFields';

export function trackNewConversationClick({ pageContext = {}, contextType } = {}) {
    const eventName = EVENT_NAMES.NEW_CONVERSATION_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildLyraAdviceFields()
    };

    if (contextType) {
        sotFields[SOT_FIELDS.NEW_CONVERSATION_CONTEXT] = contextType;
    }

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });
}
